export default "__VITE_ASSET__BTEMNFIt__"